import { createContext, useContext, useState } from "react";
import Loader from "../components/Loader";

const LoaderContext = createContext();

export function LoaderProvider({ children }) {
    const [loading, setLoading] = useState(false);
    const [text, setText] = useState("Betöltés...");

    const showLoader = (message = "Betöltés...") => {
        setText(message);
        setLoading(true);
    };

    const showSuccess = (message = "Kész!") => {
        setText(message);
    };

    const hideLoader = (delay = 300) => {
        setTimeout(() => {
            setLoading(false);
        }, delay);
    };

    return (
        <LoaderContext.Provider value={{ showLoader, hideLoader, showSuccess }}>
            {loading && <Loader text={text} />}
            {children}
        </LoaderContext.Provider>
    );
}

export function useLoader() {
    return useContext(LoaderContext);
}
